import IConfig from '../interfaces/IConfig';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const loadConfig = (env: any): IConfig => ({
    reCaptchaSiteKey: env.REACT_APP_RECAPTCHA_SITE_KEY,
    apiBaseUrl: env.REACT_APP_API_BASE_URL,
});

export default loadConfig;
